import React from 'react';
import PropTypes from 'prop-types';
import { getParticipantChipParts } from '../utils/utils';

/** Nombre + dorsal (ej. "PAULA CLAVIJO | 2200") */
const RankingParticipantLabel = ({
  person,
  className = '',
  nameClassName = 'ranking-participant__name',
  bibClassName = 'ranking-participant__bib',
  variant = 'default',
}) => {
  const { name, bib } = getParticipantChipParts(person);
  if (!name && !bib) return null;

  const isTeam = variant === 'team';

  return (
    <span className={`ranking-participant-label ${className}`.trim()}>
      {isTeam ? (
        <>
          {name ? <span className={nameClassName}>{name}</span> : null}
          {bib ? (
            <span className={`${bibClassName} team-roster__bib-suffix`}>
              {name ? ' | ' : ''}
              {bib}
            </span>
          ) : null}
        </>
      ) : (
        <span className={nameClassName}>
          {name}
          {bib ? (
            <>
              {' | '}
              <span className={bibClassName}>{bib}</span>
            </>
          ) : null}
        </span>
      )}
    </span>
  );
};

RankingParticipantLabel.propTypes = {
  person: PropTypes.object.isRequired,
  className: PropTypes.string,
  nameClassName: PropTypes.string,
  bibClassName: PropTypes.string,
  variant: PropTypes.oneOf(['default', 'team']),
};

export default RankingParticipantLabel;
